import React, { forwardRef } from 'react';
import { parseISO } from 'date-fns/parseISO';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import styledMmmField from './styledMmmField';

// shims date picker value to parse string values to date objects automatically
// falsy values default to null (a valid empty state)
const PropShim = forwardRef((props, ref) => {
  const { value } = props;
  return (
    <MuiDatePicker
      {...props}
      value={typeof value === 'string' && value ? parseISO(value) : value || null}
      ref={ref}
    />
  );
});
PropShim.displayName = 'DatePicker';
export const DatePicker = styledMmmField(PropShim);
